export default __webpack_public_path__ + "static/media/exampleIMG.bbeaaba5.png";